import ModalVidio from 'components/ModalVidio';
import SecondaryButton from 'components/SecondaryButton';
import React from 'react'
import { useEffect } from 'react';
import { useState } from 'react';
import { useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { getProfile } from 'services/apiRoutes';


export default function Header() {
    const {slug} = useParams()
    const [profile, setProfile] = useState();
    const [bgImage, setBgImage] = useState();

    const profileAPI = useCallback(async () => {
      const res = await getProfile(slug);
      if (res.error) {
        return res.message;
      } else {
        const { data } = res.data;
        setBgImage(data.ProfilDesa?.url_gambar);
        setProfile(data);
      }
    }, [slug]);

    useEffect(() => {
      profileAPI();
    }, [profileAPI, profile]);
  const navigate = useNavigate();
  return (
    <div
      className={`flex flex-col justify-center min-h-screen text-2xl font-bold text-center text-white bg-no-repeat bg-cover md:px-0 md:text-6xl header-wrapper bg-inherit relative`}
      // style={{
      //   // backgroundImage: `url('${bgImage||imgg}')`,
      //   // backgroundImage: `url('${bgImage}')`,
      //   // backgroundImage: `url('${profile?.ProfilDesa[0] ? profile?.ProfilDesa[0]?.url_gambar : null}')`,
      //   backgroundSize: "cover",
      //   backgroundPosition: "inherit",
      //   backgroundRepeat: "no-repeat",
      //   overflow: "hidden",
      // }}
    >
      <img
        src={bgImage}
        alt={profile?.ProfilDesa?.nama}
        className="absolute w-full min-h-screen -z-20"
        crossOrigin="anonymouse"
      />
      <div className="px-5 mt-64 heading-wrapper">
        <h1>Selamat Datang di Website</h1>
        <h1 className="mt-4">{profile?.ProfilDesa?.nama}</h1>
      </div>
      <div className="md:flex w-full  md:justify-center md:space-x-8 btnWrapper mt-[58px] space-y-4 md:space-y-0 px-5">
        <SecondaryButton
          label="Jelajahi Gampong"
          onClick={() => navigate("Berita")}
        />
        <ModalVidio />
      </div>
    </div>
  );
}
